import { type Route } from '#app/routes/mocra+/_sections+/+types/608.ts'
import { SECTIONS } from '#app/routes/mocra+/_sections+/section-data.ts'
import { SectionDetail } from '#app/routes/mocra+/_sections+/section-detail.tsx'

export const meta: Route.MetaFunction = () => [
	{ title: 'MoCRA — §608 Safety Substantiation' },
]

export default function Section608() {
	return <SectionDetail section={SECTIONS['608']} />
}
